import { PriceAttribute } from '@printdeal/product-selector';
import { ErrorManagement } from '@printdeal/error-management/react';
import { ISelection } from '../../../../types/selector/Selector';
import { IProductRoute } from '../../../../types/product/productDetailPage';
import { ServiceFactory } from '../../../../services/ServiceFactory';
import { parseQuery } from '../../../../helpers/utils';
import { pricePivotAttributes } from '../../../../helpers/PricesHelper';
import { ProductRouteItem } from '../components/ProductRoute';

const productService = ServiceFactory.createProductService();

export const filterPriceAttributesFromSelection = (selection: ISelection): PriceAttribute[] =>
  Object.entries(selection)
    .map(([name, value]) => ({ name, value }))
    .filter((attribute) => attribute.name !== 'Quantity' && !pricePivotAttributes.includes(attribute.name));

export const validateRoutes = async (
  productRoutes: IProductRoute[],
  productDetailPageId: string,
  customerGroupId?: string,
): Promise<ProductRouteItem[]> => {
  const validatedRoutes = await Promise.all(productRoutes.map(async (productRoute) => {
    const parsedProductCode = parseQuery(productRoute?.productCode?.internal?.content);
    const { valid, price, originalPrice } = await productService.validateSelection({
      selection: parsedProductCode.selection,
      comboSelection: parsedProductCode.comboSelection,
      productDetailPageId,
      customerGroupId,
    });

    if (valid) {
      return { productRoute, price, originalPrice };
    }

    ErrorManagement.exception({
      exception: `Invalid product route - ${productRoute.routeIdentifier}`,
      extra: {
        valid,
        productRoute: JSON.stringify(productRoute),
      },
      tags: {
        fileLocation: 'ProductRoute.tsx',
        featureFunction: 'validateProductRoutes',
      },
      fingerprint: ['invalid-product-route', productRoute.isAutoGenerated ? 'auto-generated' : 'manual'],
    });

    return undefined;
  }));

  return validatedRoutes.filter(Boolean);
};
